import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

/**
 * Permissões efetivas do usuário logado (RBAC — Fase 2).
 *
 * Consome GET /roles/my-permissions, que resolve as permissões a partir
 * do papel custom (tenantRoleId) ou cai no papel-base (retrocompatível).
 *
 * Uso para gating de UI:
 *   const { can, isLoading } = usePermissions();
 *   if (can('settings.manage')) { ... }
 *
 * NOTA: gating de UI é apenas UX — o backend é a fonte de verdade. O
 * enforcement efetivo é incremental (só alguns módulos checam por
 * permissão nesta fase).
 */
export function usePermissions() {
  const query = useQuery<string[]>({
    queryKey: ['my-permissions'],
    queryFn: async () => {
      const res = await api.get('/roles/my-permissions');
      return (res.data?.permissions as string[]) ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });

  const permissions = query.data ?? [];
  const set = new Set(permissions);

  return {
    permissions,
    can: (key: string) => set.has(key),
    isLoading: query.isLoading,
  };
}
